import type { GenericFormField } from 'components/ui/form/GenericForm/GenericForm.types.js';
import type { Country } from 'components/ui/utils/getCountries.js';
import {
  countryDatabaseSelectList,
  getCountryByCode,
} from 'components/ui/utils/getCountries.js';
import type { Control } from 'react-hook-form';

import { FormAutocomplete } from '../FormAutocomplete/FormAutocomplete.js';

type Props = {
  control: Control;
  field: GenericFormField<{
    multiple?: true;
    freeSolo?: true;
  }>;
};

export const FormCountry = (props: Props) => {
  return (
    <FormAutocomplete
      control={props.control}
      transform={{
        onChange: (code) => {
          if (Array.isArray(code)) {
            return code.map(entry => getCountryByCode(entry as string));
          } else {
            return getCountryByCode(code as string);
          }
        },
        value: (setValue) => {
          if (Array.isArray(setValue)) {
            return (setValue as Country[]).map(v => v.code);
          } else {
            return (setValue as Country | null)?.code;
          }
        },
      }}
      field={{
        ...props.field,
        options: countryDatabaseSelectList,
      }}
    />
  );
};
